import React, { Component, Fragment } from "react";
import CenterElement from "./CenterElement";
import $ from "jquery";
import { useEffect } from "react";
import { useRef } from "react";
import TFACtivityModel from "../../mcq/model/TFACtivityModel";

import TFQModel from "../../mcq/model/TFQModel";
// import TFQModel from "../../mcq/model/TFQModel";

class ReadTextUI extends Component {
  constructor() {
    super();
    // this.ref = React.createRef()
  }

  componentDidMount = () => {
    // setTimeout(()=>{window.x(this.ref.current)},100)
    // window.x(this.ref.current)
    // if (this.ref != null)
    //     window.x(this.ref)
  };

  render = () => {
    let { activity } = this.props;
    let { tfQ } = activity;
    let { readTextObj } = activity;
    let { readText } = activity;
    let { selectedStyle } = activity.readText;
    let { app, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    const regex ='<img[^>]*src="([^"]+)"[^>]*>';

    var stringToHTML = function (str) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(str, 'text/html');
      return doc.body.querySelector("img");
    };
    let imgSrc = Object(
      readText.tfReadText.match(regex)
    )[0];
      
    return (
      <Fragment>
        {readText.enabled ? (
          <>
            <div className="headertxtContainer" >
              <div
                id="readtxtContainer"
                ref={(el) => (this.ref = el)}
                className={
                  quizViwerModel.callbackData.dir == "rtl"
                    ? `readTxtcontainer-rtl ${
                        imgSrc? "readtxtContainerAndImage":"" 
                      } ${stringToHTML(imgSrc)?.style.getPropertyValue("width") >= "25%" ? "portrait":"landScape"} `
                    : `readTxtcontainer-ltr ${
                      imgSrc? "readtxtContainerAndImage":"" 
                      }`  
                }
                dangerouslySetInnerHTML={{ __html: readText.tfReadText }}
                style={{
                  float: imgSrc ? "none" : "",
                  textAlign: imgSrc ? "right" : "",
                }}
              ></div>
            </div>
            <span className={`${quizViwerModel.reviewMode ? "":"vr"}`}></span>
          </>
        ) : (
          <></>
        )}
      </Fragment>
    );
  };
}

export default ReadTextUI;
